module.exports = __webpack_public_path__ + "img/Katarina_acc_14.70d6e35d.jpg";